import { InjectionToken } from '@angular/core';
import { FortressConfig } from '@psu-pennstateit-swe/apis/fortress';
import { AnalyticsConfig } from '@psu-pennstateit-swe/utils/analytics';
import { CdnConfig } from '@psu-pennstateit-swe/utils/cdn';
import { AuthConfigWithDiscoveryDoc } from '@psu-pennstateit-swe/utils/security';
import { CollegeCostEstimatorConfig } from './core/college-cost-estimator.config';

export interface AppConfig {
  environmentLabel: string;
  featureFlags?: Record<string, boolean>;
}

export interface AppProperties {
  analytics: AnalyticsConfig;
  app: AppConfig;
  cdn: CdnConfig;
  fortress: FortressConfig;
  collegeCostEstimator: CollegeCostEstimatorConfig;
  oauth: AuthConfigWithDiscoveryDoc;
}

export const APP_CONFIG = new InjectionToken<AppConfig>('app.config');

export const APP_PROPERTIES = new InjectionToken<AppProperties>('app.properties');
